import $ from 'jquery'
import _ from 'lodash'
import { Route } from 'vue-router'

import { extractBrand, extractGroup } from './lib/extract'

export function attachGroupBrand(to: Route): void {
  const brand = extractBrand(to)
  const group = extractGroup(brand)

  /**
   * NOTE:
   * SINGLEインスタンスで、ブランド名もDOMに出力するかどうかについて議論有り.
   * https://github.com/my-color/front/pull/686
   *
   * 今後の議論次第では、SINGLEインスタンスではgroupIdのみ出力の可能性も有り得る.
   */
  const classes = _.compact([
    brand,
    group,
  ])

  $('body').addClass(classes.join(' '))
}
